import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
import icons from '../icons';
import Magnify from './Magnify';
import { imageClass } from './styles';
import { PureComponent } from '../component';
import { docSize } from '../utils/dom/document';
import normalizeWheel from '../utils/dom/normalizeWheel';
var DefaultProps = {
  current: 0
};

var Gallery =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Gallery, _PureComponent);

  var _super = _createSuper2(Gallery);

  function Gallery(props) {
    var _this;

    _classCallCheck(this, Gallery);

    _this = _super.call(this, props);
    _this.scrollX = void 0;
    _this.rawScroll = void 0;
    _this.scrollTimer = void 0;
    _this.state = {
      current: props.current,
      direction: 'init'
    };
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    _this.lockScroll = _this.lockScroll.bind(_assertThisInitialized(_this));
    _this.scrollX = 0;
    _this.rawScroll = false;
    return _this;
  }

  _createClass(Gallery, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(Gallery.prototype), "componentDidMount", this).call(this);

      document.addEventListener('wheel', this.handleScroll, {
        passive: false
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _get(_getPrototypeOf(Gallery.prototype), "componentWillUnmount", this).call(this);

      document.removeEventListener('wheel', this.handleScroll, {
        passive: false
      });
    }
  }, {
    key: "lockScroll",
    value: function lockScroll(status) {
      this.rawScroll = status;
    }
  }, {
    key: "handleClick",
    value: function handleClick(direction) {
      var _this2 = this;

      var length = this.props.images.length;
      this.setState(immer(function (draft) {
        draft.current += direction;
        if (draft.current < 0) draft.current = 0;else if (draft.current >= length) draft.current = length - 1;else draft.direction = direction === 1 ? 'forward' : 'backward';
      }), function () {
        setTimeout(function () {
          _this2.setState({
            direction: 'init'
          });
        }, 400);
      });
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(e) {
      var _this3 = this;

      if (this.rawScroll) return;
      e.preventDefault();
      if (this.scrollX !== 0) return;
      var wheel = normalizeWheel(e);
      this.scrollX += wheel.spinX;
      if (this.scrollX < 0) this.handleClick(-1);
      if (this.scrollX > 0) this.handleClick(1);
      this.scrollTimer = setTimeout(function () {
        _this3.scrollX = 0;
      }, 1000);
    }
  }, {
    key: "renderImage",
    value: function renderImage(image, pos) {
      var windowHeight = docSize.height;
      var windowWidth = docSize.width;
      var onClick;

      if (pos !== 'center') {
        onClick = this.handleClick.bind(this, pos === 'left' ? -1 : 1);
      }

      return (
        /*#__PURE__*/
        React.createElement("div", {
          key: image.key,
          className: imageClass(pos, this.state.direction),
          onClick: onClick
        },
        /*#__PURE__*/
        React.createElement("a", {
          onClick: this.props.onClose,
          className: imageClass('close')
        }, icons.Close),
        /*#__PURE__*/
        React.createElement(Magnify, {
          maxWidth: windowWidth - 400,
          maxHeight: windowHeight - 160,
          position: pos,
          src: image.src,
          lockScroll: this.lockScroll
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var current = this.state.current;
      var _this$props = this.props,
          images = _this$props.images,
          onClose = _this$props.onClose;
      var currentImage = images[current];
      var result = [];
      result.push(
      /*#__PURE__*/
      React.createElement("div", {
        key: "overlay",
        className: imageClass('overlay'),
        onClick: onClose
      }));
      result.push(this.renderImage(currentImage, 'center'));
      if (images[current - 1]) result.push(this.renderImage(images[current - 1], 'left'));
      if (images[current + 1]) result.push(this.renderImage(images[current + 1], 'right'));
      return result;
    }
  }]);

  return Gallery;
}(PureComponent);

Gallery.defaultProps = DefaultProps;
Gallery.defaultProps = {
  current: 0
};
export default Gallery;